<template>
    <div>
        <div class="container mx-auto">
            <div class="bg-orange-300 p-10 rounded-xl mt-10 text-center">
                <div class="text-2xl">Espace de développement</div>
                <div class="mt-1 font-light">Cette page est accessible uniquement en local</div>
            </div>


            <div class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-10">
                <div v-for="(alias, index) in aliases" :key="'alias-' + index">
                    <a :href="'/' + alias.url_keyname" class="block h-full bg-white hover:bg-gray-100 duration-200 cursor-pointer rounded-xl border p-10 flex items-center justify-center">
                        <img class="h-20" v-if="alias.style.logo" :src="alias.style.logo" alt="">
                        <div class="text-4xl font-extrabold" :style="'color:' + alias.style.css.defaultBgColor" v-else>
                            {{alias.name}}
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from '@/services/api.service'
export default {
    data() {
        return {
            aliases: []
        }
    },

    methods: {
        async getAliases() {
            let response = await ApiService.post('all_alias')
            this.aliases = response.data.posts.post
            this.aliases.map(alias => {alias.style = JSON.parse(alias.style)})
        }
    },

    mounted() {
        this.getAliases()
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/AllAlias.vue